import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSeoForPath, getSiteOrigin } from "@/config/seo";
import { applyJsonLd } from "@/config/jsonLd";
import { images } from "@/config/images";

// 既存のタグを再利用し、無ければ生成して content を更新する。
function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`
  );
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]'
  );
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const seo = getSeoForPath(path);
    const origin = getSiteOrigin();
    const url = origin ? `${origin}${path === "/" ? "/" : path}` : "";
    const image = images.logo;

    document.title = seo.title;

    upsertMeta("name", "description", seo.description);
    upsertMeta("name", "keywords", seo.keywords);

    if (url) {
      upsertCanonical(url);
    }

    // Open Graph
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:title", seo.ogTitle ?? seo.title);
    upsertMeta("property", "og:description", seo.ogDescription ?? seo.description);
    upsertMeta("property", "og:locale", "ja_JP");
    if (image) {
      upsertMeta("property", "og:image", image);
    }
    if (url) {
      upsertMeta("property", "og:url", url);
    }

    // Twitter Card
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", seo.ogTitle ?? seo.title);
    upsertMeta("name", "twitter:description", seo.ogDescription ?? seo.description);
    if (image) {
      upsertMeta("name", "twitter:image", image);
    }

    // Schema.org JSON-LD（メタタグ更新とは分離）
    applyJsonLd(path);
  }, [location.pathname]);

  return null;
}